import _ from 'lodash';
import { v4 } from 'uuid';
export default class Area extends Object {
    constructor(area) {
        super();
        if (area) {
            _(this).keys().each(key => {
                if (area.hasOwnProperty(key)) {
                    this[key] = area[key];
                }
            })
        }
        this.uuid = v4();
    }

    uuid = null;
    label = null;
    startX = null;
    startY = null;
    h = 0;
    w = 0;
    dragTL = false;
    dragBL = false;
    dragTR = false;
    dragBR = false;
    drag = false;
    deleteButton = {
        startX: null,
        startY: null,
        h: 20,
        w: 20
    };
    canvas = {
        height: null,
        width: null
    };

    stop() {
        this.dragTL = false;
        this.dragBL = false;
        this.dragTR = false;
        this.dragBR = false;
        this.drag = false;
    };

    isCaught() {
        return this.dragBL || this.dragBR || this.dragTL || this.dragTR || this.drag;
    }

    transformToSave() {
        return _.pick(this, [
            'startX',
            'startY',
            'h',
            'w',
            'canvas',
            'uuid'
        ]);
    }

    scale(ratio) {
        this.startX = this.startX * ratio;
        this.startY = this.startY * ratio;
        this.h = this.h * ratio;
        this.w = this.w * ratio;
    }

}

